import { STOModel } from "../../models/base/sto-model";
import { PreApproveExpenseReportDTO } from "../../models/pre-approve-expense-report/pre-approve-expense-report";
import { BaseApiService } from "../base";

export class PreApproveExpenseReportApiService extends BaseApiService<PreApproveExpenseReportDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/ExpenseReports",
      loadItemsPath: "/PreApproveExpenseReportsByLink",
    });
  }
}
